module.exports = __webpack_public_path__ + "img/flutter.4cdf0d75.svg";